import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalService } from '../core/services/local.service';
import { AuthService } from '../core/services/auth.service';

export const parseUserDataFromLocalStore = () => {
  const localService = inject(LocalService);
  const userData = localService.getData('visitorms_user');
  return {
    role: userData?.role,
    isLoggedIn: !!userData,
    isProfileComplete: userData?.isProfileComplete,
  };
};

export const authAdminGuard: CanActivateFn = (route, state) => {
  const { role, isLoggedIn } = parseUserDataFromLocalStore();
  const authService = inject(AuthService);
  const { hasValidToken } = authService;
  const router = inject(Router);

  const isAdmin = ['superadmin', 'appointment', 'checkin', 'staff'].includes(role);

  if (hasValidToken() === false) {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }
  if (!!hasValidToken()) {
    if (!isAdmin) {
      router.navigate(['/'], { replaceUrl: true });
      return false;
    }
    return true;
  }

  return false;
};

export const authSysadminGuard: CanActivateFn = (route, state) => {
  const { role, isLoggedIn } = parseUserDataFromLocalStore();
  const authService = inject(AuthService);
  const { hasValidToken } = authService;
  const router = inject(Router);

  const isAdmin = ['sysadmin'].includes(role);

  if (hasValidToken() === false) {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }
  if (!!hasValidToken()) {
    if (!isAdmin) {
      router.navigate(['/'], { replaceUrl: true });
      return false;
    }
    return true;
  }

  return false;
};

export const blockStaffGuard: CanActivateFn = (route, state) => {
  const { role } = parseUserDataFromLocalStore();
  const router = inject(Router);

  if (role === 'staff') {
    router.navigate(['/admin'], { replaceUrl: true });
    return false;
  }

  return true;
};
